import * as Sentry from '@sentry/react'

export const handleErrorResponseFromBackend = error => {
  const { data: { code } = {}, traceId } = error || {}

  Sentry.setContext('error', {
    ...(traceId && { internalTraceId: error.traceId }),
    ...(code && { 'error.code': code }),
  })
}
